import { gql } from '@apollo/client';

export const stopItGql = gql`
  mutation stopIt($id: String!) {
    stopIt(id: $id) {
      _id
    }
  }
`;
